import React from 'react';
import './footer.css';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import EmailIcon from '@material-ui/icons/Email';
import behance from '../assets/behance-footer.svg';
import behancebig from '../assets/behance.svg';


export default function Footer (){
  const futureVersion = () => alert("Not so fast. We'll get there ;-)");
  const iconProps = {
    fontSize: "large",
    color: "action"
  }
  return(
  <div className="footer" id="contact">    
    <div className="socialIcons">
       <a href="mailto:marcelo@mleite.com.br" title="Marcelo's Email address">
        <EmailIcon {...iconProps} />
      </a>      
      <a href="https://github.com/marceloleitemt/" target="_blank" rel="noopener noreferrer" title="Marcelo's Git Profile">
        <GitHubIcon {...iconProps} />
      </a>
      <a href="https://twitter.com/marceloleitemt" target="_blank" rel="noopener noreferrer" title="Marcelo's Twitter Account">
        <TwitterIcon {...iconProps} />
      </a>
      <a href="https://www.linkedin.com/in/marceloleitemt/" target="_blank" rel="noopener noreferrer" title="Marcelo's LinkedIn profile">
        <LinkedInIcon {...iconProps} />
      </a>
      <a href="https://www.behance.net/marceloleite" target="_behance">
        <img src={behance} alt="My Portfolio on Behance" className="behancefooter"title="Marcelo's Behance portfolio"/>
      </a>
    </div>
    <div className="copyright">
    <a href="http://www.mleite.com.br/resume2015/" target="_portfolio"><button>Previous Version 2015</button></a> | <span>Marcelo Leite - 2020</span> | <button onClick={futureVersion}>Future Version 2025</button>
    </div>
  </div>
  );
}